import { render, staticRenderFns } from "./treeReportDetail.vue?vue&type=template&id=1f92ffb6&scoped=true&"
import script from "./treeReportDetail.vue?vue&type=script&lang=js&"
export * from "./treeReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./treeReportDetail.vue?vue&type=style&index=0&id=1f92ffb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92ffb6",
  null
  
)

export default component.exports